import { render, staticRenderFns } from "./EdpOffersView.vue?vue&type=template&id=7cb5defa&scoped=true&"
import script from "./EdpOffersView.vue?vue&type=script&lang=js&"
export * from "./EdpOffersView.vue?vue&type=script&lang=js&"
import style0 from "./EdpOffersView.vue?vue&type=style&index=0&id=7cb5defa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb5defa",
  null
  
)

export default component.exports